<template>
  <div>
    <b-card class="col-4" no-body>
      <div class="m-2">

        <!-- Table Top -->
        <b-row class="pb-1">
          <b-col cols="12">
            <b-form-group label="Số iTel cần giữ">
              <validation-provider #default="{ errors }">
                <b-form-input v-model="Phone" :state="errors.length > 0 ? false:null"/>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Trạng thái">
              <validation-provider #default="{ errors }">
                <Select2 v-model="Status" :options="statusList" :state="errors.length > 0 ? false:null"/>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col class="text-left" cols="12">
            <b-form-group>
              <b-button
                  class="btn"
                  variant="primary" @click="handleOk()">
                Cập nhật trạng thái
              </b-button>
            </b-form-group>
          </b-col>
          <!-- Per Page -->
        </b-row>
      </div>
    </b-card>


  </div>
</template>

<script>


import {ValidationObserver, ValidationProvider} from 'vee-validate'
import {required} from '@validations'
import vSelect from 'vue-select'
import {VueGoodTable} from 'vue-good-table'
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTable,
  BTooltip,
  VBTooltip
} from 'bootstrap-vue'
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from 'vue-ripple-directive'
import '@core/scss/vue/libs/vue-good-table.scss';
import Select2 from 'v-select2-component';


export default {

  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2
  },

  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  mounted() {


  },
  watch: {},
  methods: {
    loading(status) {
      document.querySelector("#loading-bg").style.display = status ? "block" : "none";
    },
    async handleOk() {
      this.loading(true);
      await this.fetchNumberInfo();
      var url = 'masterData/Inventory';
      useJwt.put(url, {
        Phone: this.Phone,
        Status: this.Status,
        saleChannel: this.numberInfo.SaleChannels ? this.numberInfo.SaleChannels.split(',') : []
      })
          .then(response => {
            this.loading(false);
            this.$toast({
              component: ToastificationContent,
              props: {title: 'Cập nhật trạng thái thành công!', icon: 'CheckSquareIcon', variant: 'primary'}
            })
          })
          .catch(error => {
            this.loading(false);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Lỗi cập nhật trạng thái [' + error.response.data.result + ']!',
                icon: 'AlertTriangleIcon',
                variant: 'danger'
              }
            })
          })
    },
    async fetchNumberInfo() {
      await useJwt
          .post("getMasterData/Inventory", {
            columnFilters: {
              Phone: this.Phone
            },
            sort: [],
            page: 1,
            pageSize: 50
          })
          .then((response) => {
            this.numberInfo = response.data.result[0];
          })
          .catch((error) => {
            console.log(error);
          });

    }
  },
  data() {
    return {
      Phone: 0,
      isLoading: false,
      totalRecords: 0,
      Status: '11',
      statusList: [
        {id: '0', text: 'Sẵn sàng'},
        {id: '1', text: 'Đã bán - chưa kích hoạt'},
        {id: '2', text: 'Đã bán - đã kích hoạt'},
        {id: '10', text: 'iTel giữ số'},
        {id: '11', text: 'Lỗi VnPay, chờ kiểm tra'}
      ],
      numberInfo: {
        SaleChannels: ''
      },
      required
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
